import React, { Component } from "react";
import DownArrowIcon from "../../icons/arrow-icon";

import db from "../../services/query";

import { HalfYearContext } from "../../contexts/halfYearContext";

class HalfYearDropDown extends Component {
  static contextType = HalfYearContext;

  state = {
    data: [],
    defaultOption: [],
  };

  componentDidMount = async () => {
    await db.getAll("dropdowns/halfYears").then(({ data: { data } }) => {
      const defaultOption = data.filter((opt) => opt.is_current)[0];

      this.setState({ data, defaultOption });
    });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    return this.state.data != nextState.data;
  };

  handleSelect = ({ currentTarget: select }) => {
    const { setHalfYear } = this.context;

    setHalfYear(select.value);
  };

  render() {
    const { data, defaultOption } = this.state;

    return (
      <div className="header-half-year">
        <main>
          <select name="half-year-drp" onChange={(e) => this.handleSelect(e)}>
            <option hidden>{defaultOption?.name}</option>
            {data.map((opt) => (
              <option
                key={opt.id}
                value={opt.id}
                style={{ color: defaultOption === opt && "var(--blue)" }}
              >
                {opt.name}
              </option>
            ))}
          </select>
          <i>
            <DownArrowIcon />
          </i>
        </main>
      </div>
    );
  }
}

export default HalfYearDropDown;
